/// <amd-module name="SuiteCommerce.LookBook.Look.Collection"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("SuiteCommerce.LookBook.Look.Collection", ["require", "exports", "Backbone", "SuiteCommerce.LookBook.Look.Model"], function (require, exports, Backbone_1, Look_Model_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.LookCollection = void 0;
    var LookCollection = /** @class */ (function (_super) {
        __extends(LookCollection, _super);
        function LookCollection() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.model = Look_Model_1.LookModel;
            return _this;
        }
        return LookCollection;
    }(Backbone_1.Collection));
    exports.LookCollection = LookCollection;
});
